import React, { FC } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "@mui/material";

const EditButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <section>
      <Button onClick={onClick} variant="text" startIcon={<EditIcon />}>
        Edit
      </Button>
    </section>
  );
};

export default EditButton;
